import { render, staticRenderFns } from "./error-messages.vue?vue&type=template&id=228f0297&scoped=true&"
import script from "./error-messages.vue?vue&type=script&lang=js&"
export * from "./error-messages.vue?vue&type=script&lang=js&"
import style0 from "./error-messages.vue?vue&type=style&index=0&id=228f0297&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f0297",
  null
  
)

export default component.exports